import { useRef, useEffect } from 'react';

export function useDidUpdate(callback, deps) {
  const isMounted = useRef();

  useEffect(() => {
    if (!isMounted.current) {
      // do componentDidMount logic
      isMounted.current = true;
    } else {
      // do componentDidUpdate logic
      callback();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
